export default "__VITE_ASSET__87af8c03__"